// RaporteazaAnimalutPierdut.jsx
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FormularAnunt from "../components/FormularAnunt";
import ListaAnunturiMele from "../components/ListaAnunturiMele";
import "./Dashboard.css";
import { RiLogoutBoxLine } from "react-icons/ri";

export default function RaporteazaAnimalutPierdut() {
  const { user, loading, logout } = useAuth();
  const [tab, setTab] = useState("posteaza");
  const navigate = useNavigate();

  if (loading) return <div className="loading">Se încarcă...</div>;
  if (!user) return <Navigate to="/" />;

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="dashboard-user">
          <img
            src={user.user_metadata?.avatar_url}
            alt="avatar"
            className="dashboard-avatar"
          />
          <span>{user.user_metadata?.full_name || user.email}</span>
          <button className="btn-logout" onClick={handleLogout}>
            <RiLogoutBoxLine /> Ieși din cont
          </button>
        </div>
        <h1>Mi-am pierdut animaluțul</h1>
        <p>Postează un anunț și comunitatea te va ajuta</p>
      </div>

      <div className="dashboard-tabs">
        <button
          className={tab === "posteaza" ? "tab active" : "tab"}
          onClick={() => setTab("posteaza")}
        >
          Postează anunț
        </button>
        <button
          className={tab === "lista" ? "tab active" : "tab"}
          onClick={() => setTab("lista")}
        >
          Anunțurile mele
        </button>
        <button
          className={tab === "promovate" ? "tab active" : "tab"}
          onClick={() => setTab("promovate")}
        >
          ⭐ Anunțuri Promovate
        </button>
      </div>

      <div className="dashboard-content">
        {tab === "posteaza" && (
          <FormularAnunt tip="pierdut" onSuccess={() => setTab("lista")} />
        )}
        {tab === "lista" && (
          <ListaAnunturiMele tip="pierdut" />
        )}
        {tab === "promovate" && (
          <ListaAnunturiMele tip="pierdut" doarPromovate={true} />
        )}
      </div>
    </div>
  );
}